import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API, getShareToken, setShareToken, formatApiError } from "../lib/api";
import Deck from "./Deck";
import ShareGate from "./ShareGate";
import { LogoMark } from "../components/Logo";
import { renderSlide } from "./slides";

export default function DeckPage() {
  const [state, setState] = useState("loading"); // loading | gate | ready | error
  const [slides, setSlides] = useState([]);
  const [gateError, setGateError] = useState("");
  const [gateLoading, setGateLoading] = useState(false);

  const loadDeck = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/deck`, {
        headers: { "X-Share-Token": getShareToken() },
      });
      setSlides(data.slides);
      setState("ready");
      if (!sessionStorage.getItem("proaura_tracked")) {
        sessionStorage.setItem("proaura_tracked", "1");
        axios.post(`${API}/track`, { ref: document.referrer || null }).catch(() => {});
      }
    } catch (e) {
      if (e.response?.status === 401) setState("gate");
      else setState("error");
    }
  }, []);

  useEffect(() => {
    loadDeck();
  }, [loadDeck]);

  const submitPassword = async (password) => {
    setGateLoading(true);
    setGateError("");
    try {
      const { data } = await axios.post(`${API}/deck/access`, { password });
      setShareToken(data.token);
      await loadDeck();
    } catch (e) {
      setGateError(formatApiError(e, "Password errata"));
    } finally {
      setGateLoading(false);
    }
  };

  if (state === "loading") {
    return (
      <div className="h-[100dvh] flex flex-col items-center justify-center gap-4 bg-white" data-testid="deck-loading">
        <div className="animate-pulse">
          <LogoMark size={44} />
        </div>
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
          Caricamento presentazione
        </div>
      </div>
    );
  }

  if (state === "error") {
    return (
      <div className="h-[100dvh] flex flex-col items-center justify-center gap-4 bg-white" data-testid="deck-error">
        <LogoMark size={40} />
        <p className="text-slate-500 text-sm">Impossibile caricare la presentazione.</p>
        <button
          data-testid="deck-retry-button"
          onClick={() => {
            setState("loading");
            loadDeck();
          }}
          className="px-5 py-2.5 rounded-full bg-ink text-white text-sm font-display font-semibold"
        >
          Riprova
        </button>
      </div>
    );
  }

  if (state === "gate") {
    return <ShareGate onSubmit={submitPassword} error={gateError} loading={gateLoading} />;
  }

  return (
    <>
      <Deck slides={slides} />
      <div className="print-only">
        {slides.map((s) => (
          <div key={s.id} className="print-slide">
            {renderSlide(s, { isPrint: true })}
          </div>
        ))}
      </div>
    </>
  );
}
